module.exports = __webpack_public_path__ + "img/noun-crash-4860217.739c9e52.svg";